import { convertFormDataToFilesJson } from './generics-conversion-service';
var convertFormDataToAbstractCreateRequest = function convertFormDataToAbstractCreateRequest(data) {
  var _data$wordCountRange;
  var wordCountRange = (_data$wordCountRange = data.wordCountRange) !== null && _data$wordCountRange !== void 0 ? _data$wordCountRange : [150, 250];
  return {
    files: convertFormDataToFilesJson(data),
    styleOfEnglish: data.styleOfEnglish,
    origin: 'aje',
    abstractType: data.abstractType,
    wordLimitMin: wordCountRange[0],
    wordLimitMax: wordCountRange[1],
    includeSimpleSummary: data.additionalOutputs.simpleLanguageSummary ? 'true' : 'false',
    includeGraphicalAbstract: data.additionalOutputs.graphicalAbstract ? 'true' : 'false'
  };
};
export default convertFormDataToAbstractCreateRequest;